import { z } from "zod";

export const AuditLogTypeSchema = z.enum([
  "BILL",
  "SPEND_REQUEST",
  "VENDOR",
  "SERVICE",
  "DOCUMENT",
  "INTAKE_SUBMISSION",
  "INTAKE_WORKFLOW",
  "MEMBER",
  "GROUP",
  "PURCHASE_ORDER",
  "INTAKE_CATEGORY",
]);

export type AuditLogType = z.infer<typeof AuditLogTypeSchema>;
